import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getListSupplier = createAsyncThunk('/dashboardsupplier/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listSupplier/${userId}`, {})
    return response.data;
})

export const dashboardSupplierSlice = createSlice({
    name: 'dashboardsupplier',
    initialState: {
        isLoading: false,
        dashboardsupplier: []
    },

    /*extraReducers: {
        [getListSupplier.pending]: state => {
            state.isLoading = true
        },
        [getListSupplier.fulfilled]: (state, action) => {
            state.dashboardsupplier = action.payload.data
            state.isLoading = false
        },
        [getListSupplier.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getListSupplier.pending, (state) => {
                state.isLoading = true;
            })               
            .addCase(getListSupplier.fulfilled, (state, action) => {
                state.dashboardsupplier = action.payload.data;
                state.isLoading = false;
            })               
            .addCase(getListSupplier.rejected, (state) => {
                state.isLoading = false;
            });               
    }   
})

export default dashboardSupplierSlice.reducer